/* @flow */

import * as React from 'react';
import { useIntl } from 'react-intl';

import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import styles from './CheckInButton.style';

import type { Braindate } from '@braindate/domain/lib/braindate/type';
import messages from 'src/shared/app/check-in/l10n/checkInL10n';
import useSelf from 'src/shared/domain/user/hook/useSelf';
import PrimaryButton from 'src/shared/ui/component/button/PrimaryButton';
import SecondaryButton from 'src/shared/ui/component/button/SecondaryButton';
import { hasUserCheckedIn } from 'src/shared/app/check-in/util/checkInUtil';
import CircledCheckIcon from 'src/shared/ui/component/icon/CircledCheckIcon';

type Props = {
  isBraindateCheckInReady: boolean,
  isFetching: boolean,
  braindate: Braindate,
  onClick: () => void,
};
const useStyles = createUseThemeStyles(styles);

const CheckInButtonDumb = ({
  onClick,
  isBraindateCheckInReady,
  isFetching,
  braindate,
}: Props): React.Node => {
  const intl = useIntl();
  const classes = useStyles();
  const selfUser = useSelf();
  const hasUserCheckedInBoolean =
    selfUser && hasUserCheckedIn(braindate, selfUser);
  const CheckinComponent =
    !hasUserCheckedInBoolean && !isFetching ? PrimaryButton : SecondaryButton;

  return (
    <CheckinComponent
      onClick={onClick}
      isSubmitting={isFetching}
      isDisabled={
        !isBraindateCheckInReady || hasUserCheckedInBoolean || undefined
      }
      withSuccess
    >
      {!isFetching && <CircledCheckIcon className={classes.joinIcon} />}
      {intl.formatMessage(
        hasUserCheckedInBoolean ? messages.checkedInButton : messages.checkIn,
      )}
    </CheckinComponent>
  );
};

export default React.memo<Props>(CheckInButtonDumb);
